import { useQueryClubFeatureFlagsAsPublic } from "@gymflow/api";
import { cn } from "@gymflow/helpers";
import { useHistory } from "react-router";

import { usePortalRoutes } from "../../hooks";
import { SignUpFormLoader, useClubSettings } from "../../providers";
import { SignUp } from "../../providers/authentication/SessionOverlay/SignUp";
import { RouteFeature } from "../../routes";
import useGymflowModels from "../../store";

export function SiteRegistration() {
  const { isEmbed, createSiteOrEmbedLink } = usePortalRoutes();
  const history = useHistory();
  const { api } = useGymflowModels();
  const settings = useClubSettings();
  const { data: featureFlags } = useQueryClubFeatureFlagsAsPublic({
    api,
    clubId: settings?.clubId,
  });

  return (
    <div
      className={cn(
        "track-height flex justify-center overflow-y-auto bg-gray-0 dark:bg-gray-950",
        {
          "h-fit": isEmbed,
          "h-full": !isEmbed,
        },
      )}
    >
      <div className="flex h-full w-[calc(100vw-2rem)] max-w-lg">
        {featureFlags?.featureFlags.ONBOARDING_FLOW ? (
          <SignUp
            onSuccess={async () => {
              history.push(createSiteOrEmbedLink(RouteFeature.SiteProfile));
            }}
          />
        ) : (
          <SignUpFormLoader />
        )}
      </div>
    </div>
  );
}
